import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export type Mode = 'info' | 'success' | 'error';

@Component({
	standalone: false,
	selector: 'visiba-alert',
	host: {
		'[style.display]': 'block',
	},
	template: `
		<div class="alert" [ngClass]="classMap">
			<div class="alert__header" *ngIf="heading">{{ heading }}</div>
			<div class="alert__message" *ngIf="message">{{ message }}</div>
			<ng-content></ng-content>
		</div>
	`,
})
export class VisibaAlertComponent {
	private _showExit = false;
	private _mode: Mode = 'success';
	private _heading: string;
	private _message: string;
	classMap;
	@Output() onClose: EventEmitter<boolean> = new EventEmitter();

	@Input()
	set mode(value: Mode) {
		this._mode = value;
	}

	get mode(): Mode {
		return this._mode;
	}

	@Input()
	set heading(value: string) {
		this._heading = value;
	}

	get heading(): string {
		return this._heading;
	}

	@Input()
	set message(value: string) {
		this._message = value;
	}

	get message(): string {
		return this._message;
	}

	updateMode() {
		this.classMap = {
			[`-${this.mode}`]: true,
		};
	}

	ngOnInit() {
		this.updateMode();
	}
}
